export default "__VITE_ASSET__TKl5CE0k__"